import { render } from "./SelfServiceEmailChange.vue?vue&type=template&id=2660183c&scoped=true"
import script from "./SelfServiceEmailChange.vue?vue&type=script&lang=js"
export * from "./SelfServiceEmailChange.vue?vue&type=script&lang=js"

import "./SelfServiceEmailChange.vue?vue&type=style&index=0&id=2660183c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2660183c"]])

export default __exports__